module.exports = {"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-portfolio-item.json
// module id = 152
// module chunks = 60335399758886 181753073384772